/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/EntityState
 * @desc EntityState filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { EntityState } from 'labstep-web/models/entity-state.model';
import type React from 'react';
import FilterPostNewIndexEntityStateForm from './Form';
import type { FilterPostNewIndexEntityStateProps } from './types';

export const FilterPostNewIndexEntityState: React.FC<
  FilterPostNewIndexEntityStateProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${EntityState.getHumanReadableEntityName(false, true)}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexEntityStateForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
